import { translate } from '../../../common/utility/DisplayPrep';
const defaultUiConfig = {
    name: 'Concepts',
    withActions: ['select'],
    primaryKey: 'codeId',
    properties: {
        codeId: {
            rowDisplay: false,
            sortable: true,
            name: 'Code ID'
        },
        code: {
            rowDisplay: true,
            nullable: false,
            sortable: true,
            input: 'text',
            name: 'Code'
        },
        displayName: {
            rowDisplay: true,
            nullable: false,
            input: 'text',
            sortable: true,
            name: 'Name'
        },
        description: {
            rowDisplay: false,
            sortable: true,
            input: 'multiline',
            name: 'Description'
        },
        lastDeployedDate: {
            rowDisplay: false,
            sortable: true,
            input: 'valueDisplay',
            name: 'Deployed Date',
            displayPrep: 'FullDate',
            additionalProperties: {
                Cell: ({ cell: { value } }) => {
                    return translate.ReadableDateTimeColumn(value);
                }
            }
        },
        uuid: {
            rowDisplay: false,
            sortable: true,
            name: 'Uuid'
        },
        dtoState: {
            name: 'DTO State',
            rowDisplay: false,
            editable: false
        },
        lastModId: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified ID'
        },
        lastModDatetime: {
            rowDisplay: false,
            sortable: true,
            name: 'Last Modified Datetime'
        },
        createId: {
            rowDisplay: false,
            sortable: true,
            name: 'Create ID'
        },
        createDatetime: {
            rowDisplay: false,
            sortable: true,
            name: 'Create Datetime'
        },
        auditId: {
            rowDisplay: false,
            sortable: true,
            name: 'Audit ID'
        }
    },
    newDoc: {}
};

export default defaultUiConfig;
